import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

// MUI Components
import { Button, Paper, Typography } from '@mui/material';

// MUI Icons
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

// Contexts
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';

// Helpers
import { fetchWrapperNoAuth, SERVER } from '../../utils/helpers';

const SuperUserBox = () => {
  const { user, logout, userSU, passwordSU, subUsers } = useAuth(); // Use isAuthSU from AuthContext
  const { theme } = useTheme();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [llc, setLlc] = useState("");

  useEffect(() => {
    const foundUser = subUsers.find(u => u.email === user);
    setName(foundUser?.name);
    setLlc(foundUser?.business);
  }, []);

  const handleGoBack = async () => {
    // save batches and then reset localStorage
    const AddItem = JSON.parse(localStorage.getItem("IFAddItemProccess") || '{}');
    const AddItemsBulk = JSON.parse(localStorage.getItem("IFAddItemsBulkProccess") || '{}');
    const CsvUpload = JSON.parse(localStorage.getItem("IFCsvUploadProccess") || '{}');
    const CsvUploadsBulk = JSON.parse(localStorage.getItem("IFCsvUploadsBulkProccess") || '{}');
    const MarterBuyList = JSON.parse(localStorage.getItem("IFMarterBuyListProcess") || '{}');
    const MarterBuyListsBulk = JSON.parse(localStorage.getItem("IFMarterBuyListsBulkProcess") || '{}');

    const sentItemsSU = JSON.parse(localStorage.getItem("IFSentItemsSU") || '{}');

    // Save to SuperUser table
    const batches = {
      "AddItem": AddItem,
      "AddItemsBulk": AddItemsBulk,
      "CsvUpload": CsvUpload,
      "CsvUploadsBulk": CsvUploadsBulk,
      "MarterBuyList": MarterBuyList,
      "MarterBuyListsBulk": MarterBuyListsBulk
    };

    const body = {
      email: user,
      emailSU: userSU,
      batches: batches,
      sentItems: sentItemsSU[user]
    };
    try {
      await fetchWrapperNoAuth(`${SERVER}/falcon_save_batches_su`, userSU, passwordSU, { method: "POST", body: body });
    } catch (e) {
      console.error(e);
    }

    localStorage.removeItem("IFAddItemProccess");
    localStorage.removeItem("IFAddItemsBulkProccess");
    localStorage.removeItem("IFCsvUploadProccess");
    localStorage.removeItem("IFCsvUploadsBulkProccess");
    localStorage.removeItem("IFMarterBuyListProcess");
    localStorage.removeItem("IFMarterBuyListsBulkProcess");

    localStorage.removeItem("IFSentItemsSU");

    // Log out from sub-user and return to super user dashboard
    logout();

    // superUser Login
    navigate('/super-user');
  };

  const styles = {
    paper: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: theme.color.secondary,
      color: theme.text.negative,
      paddingLeft: 1,
      paddingRight: 2,
      borderRadius: '0px 0px 8px 8px'
    },
    button: {
      minWidth: 'unset',
      fontSize: '0.7rem',
      '&:hover': {
        backgroundColor: `${theme.color.primary}55`,
      },
      textTransform: 'none',
      fontFamily: theme.fontFamily,
      color: theme.text.negative,
      borderRadius: '10px',
      backgroundColor: theme.color.primary,
      border: `1px solid ${theme.border.light}`,
    }
  }

  return (
    <Paper elevation={2} sx={styles.paper}>
      <Button
        variant="contained"
        size="small"
        onClick={handleGoBack}
        sx={styles.button}
        startIcon={<ArrowBackIcon fontSize="small" />}
      >
        Go back to Super User
      </Button>
      <Typography variant="body2" sx={{ fontFamily: theme.fontFamily }}>
        Name: {name}
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: theme.fontFamily }}>
        Business: {llc}
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: theme.fontFamily }}>
        Logged in as: {user}
      </Typography>
    </Paper>
  );
};

export default SuperUserBox;